export const PAYMENTS_DASHBOARD_URL = '/finance_payments.php';

const CREDIT_CARD_PROVIDERS = {
    STRIPE: {
        label: 'Stripe',
        value: 'STRIPE',
    },
    CARDCONNECT: {
        label: 'Fiserv',
        value: 'CARDCONNECT',
    },
    COMMONSKU_PAYMENTS: {
        label: 'commonsku payments',
        value: 'CSKUPAYMENTS',
    },
    NONE: {
        label: 'None',
        value: '',
    },
} as const;

export default CREDIT_CARD_PROVIDERS;
